// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-4c33c930]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.footer-widget-edit-wrap .check span[data-v-4c33c930]{color:hsla(0,0%,100%,.6);font-size:14px;margin:0 8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
